import { FIELD_TYPE } from '@/constants'


const categories = [
  { name: 'rentMortgage', base: {} },  
  { name: 'securityDeposit', base: {} },  
  { name: 'utilities', base: {} },
  { name: 'carAssistance', base: {} },
  { name: 'transportation', base: {} },
  { name: 'medicalExpenses', base: {} },
  { name: 'childCare', base: {} },
  { name: 'other', base: {} }
  
]

export function generateDocumentField(categoryName) {
  return {
    vHtmlLabel() {
      const config = this.getSupportDocCategoryConfig(categoryName)
      return config && config.label
    },
    vHtmlDescription() {
      const config = this.getSupportDocCategoryConfig(categoryName)
      return config && config.description
    },
    category: categoryName,
    apiKey: `supportingDocuments.${categoryName}.includeFiles`,
    fields: [
      {
        apiKey: `supportingDocuments.${categoryName}.files`,
        label: 'Upload File(s)',
        required(application) {
          const service = application.services.type          
          if (service && service.find(item => item === categoryName)) {            
            return service.find(item => item === categoryName).length > 0
          }
        },
        accept() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.supportedMIMETypes
        },
        category: categoryName,
        sizeLimitMB() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.sizeLimitMB
        },
        fileLimit() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return config && config.fileLimit
        },
        vHtmlDescription() {
          const config = this.getSupportDocCategoryConfig(categoryName)
          return (
            config &&
            config.helpText &&
            `<span class="grey--text text--lighten-2">${config.helpText}<span>`
          )
        },
        placeholder: 'Attach files',
        type: FIELD_TYPE.DOCUMENTS
      }
    ]
  }
}

export default [
  {
    label: 'Proof of Services',
    vHtmlDescription:
      '<p>Here is the additional documentation required for all clients based on the type of assistance being requested.</p>' +
      '<p>Please determine which category best fits you, and submit the proofs that are required for that specific category.</p>' +
      "<p>You may be asked for additional documentation as your case progresses. Please note that BBEA staff may contact the landlord or vendor, etc, to verify the information needed to process your case.</p>",
    type: FIELD_TYPE.HEADING
  },
  {
    type: FIELD_TYPE.PANELS,
    panels: categories.map(category => ({
      ...category.base,
      ...generateDocumentField(category.name)
    }))
  }
]
